export default {

    setProducts(state,payload){
        state.products = payload
    },
    setEutelsatProducts(state,payload){
        state.eutelsat_products = payload
    },
}
